import React, { useRef } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { message } from 'antd'
import { useLocalization } from '@contexts/LocalizationContext'
import PageLayout from '@layouts/PageLayout'
import FormComponent from './Form'
import Fetch from '@components/CRUD/Fetch'
import { client } from '@utils/client'

const Edit = () => {
  const history = useHistory()
  const fetchRef = useRef(null)
  const params = useParams()
  const { t } = useLocalization()

  const handleSubmit = async (data) => {
    try {
      await client.patch(`/specialist/${params.id}`, data)
      message.success('สำเร็จ')
      history.push(`/specialties/${params.id}`)
    } catch (e) {
      message.error('ไม่สำเร็จ')
    }
  }

  const fetch = async () => {
    const result = await client
      .get(`/specialist/${params.id}`)
      .then((res) => res.data)
    return result
  }

  return (
    <Fetch fetch={fetch} ref={fetchRef}>
      {(data) => (
        <PageLayout title={t('specialty.editScreen.title')} extra={[]}>
          <FormComponent defaultValues={data} handleSubmit={handleSubmit} />
        </PageLayout>
      )}
    </Fetch>
  )
}

export default Edit
